/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : PlayAgainService
* @file : PlayAgainService.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of PlayAgainService
*
* Created on : 24-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
import axios from 'axios';
import $ from 'jquery';
const API_URL = 'https://quiz.wanitsch.ch/quiz/quiz_app.php';

class PlayAgainService
{
	async getSession()
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','get_session');
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}
}

export default PlayAgainService;